// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BadgeOnBackorder from "@eisinc/XDL/Icons/BadgeOnBackorder";
import BadgeSchedulingUnavailable from "@eisinc/XDL/Icons/BadgeSchedulingUnavailable";
import CartWarning from "@eisinc/XDL/Icons/CartWarning";
import Close from "@eisinc/XDL/Icons/Close";
import StockInStock from "@eisinc/XDL/Icons/StockInStock";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xBaseTheme } from "@eisinc/XDL/types";
import { color, hideElementOnPrint } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            css: css`
                position: absolute;
                top: 12px;
                right: 3px;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                &:hover ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 10,
            color: "common.ui6",
            css: css`
                width: 12px;
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 10px;
            `,
        },
        iconSrcByMessage: {
            success: StockInStock,
            warning: CartWarning,
            danger: BadgeOnBackorder,
            info: BadgeSchedulingUnavailable,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                &,
                ${TypographyStyle} {
                    font-size: ${fontConfig.small.size}px;
                    line-height: ${fontConfig.small.lineHeight};
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                border-radius: 2px;
                ${hideElementOnPrint}
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
                padding: 14px 27px 14px 12px;
                margin-top: 2px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
